import React from 'react';
import PropTypes from 'prop-types';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { functional, neutral900, promoCta } from '@fever/ui';
import MuiThemeProvider, { promoTheme, promoThemeClient } from 'styles/MuiThemeProvider';

export default function ProviderTheme({ children }) {
    const theme = IS_EDITOR_MODE
        ? promoTheme
        : promoThemeClient({
              primaryColor: functional,
              secondaryColor: promoCta,
              textColor: neutral900
          });

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

ProviderTheme.propTypes = {
    children: PropTypes.node
};
